import { RoomLifecycleState } from './types'

export const DEFAULT_ROOM_LIFECYCLE: RoomLifecycleState = {
  audioExperienceStarted: false,
  
  phase: 'new_origin',

  isFirstSystemEntry: true,

  hasAcceptedOriginRole: false,

  genesisStartedAt: null,

  genesisCompletedAt: null,

  firstHeartbeatAt: null,

  firstHeartbeatViewedAt: null,

  narrator: {
    speaker: null,

    speaking: false,

    message: null,
  },

  consoleActivated:false,

  consoleOpened:false,

  windowActivated:false,

  windowOpened:false,
}